import { gql } from "graphql-tag"

export default gql`
  type StoreLink {
    createdAt: String!
    currencyCode: String
    currencySymbol: String
    id: ID!
    isInStock: Boolean
    isPreOrder: Boolean!
    isPublished: Boolean!
    priceAmount: Int
    priceFormatted: String
    publishedAt: String
    store: Store!
    updatedAt: String!
    url: String!
  }

  input StoreLinkAddInput {
    isPreOrder: Boolean
    isPublished: Boolean
    storeId: ID!
    url: String!
  }

  input StoreLinkUpdateInput {
    id: ID
    isPreOrder: Boolean
    isPublished: Boolean
    publishedAt: String
    storeId: ID
    url: String
  }

  enum StoreToggleAction {
    PREORDER
    BUY
  }

  input BulkStoreToggleInput {
    action: StoreToggleAction!
    homeVideoId: ID!
    storeLinkIds: [ID!]
    value: Boolean!
  }

  type BulkStoreTogglePayload {
    homeVideo: HomeVideo!
    updatedStoreLinkIds: [ID!]!
  }
`
